const swagger = {
    invalid_zod_type: '無效的 Zod 類型，請檢查路由驗證設定。',
    not_supported_zod_type_for_params: '請求參數不支援此 Zod 類型，請檢查路由驗證設定。',
};
export default Object.freeze(swagger);
